import React from 'react';
import { render } from 'react-dom';

import OrderFooter from '@/common/components/OrderFooter';

const element = document.querySelector('[data-view="order-footer"]');

if (element) {
    Mobi2Go.onReady(() => {
        render(<OrderFooter />, element);
    });
}
